import { PropsWithChildren, ReactNode, useEffect, useRef } from 'react';

import s from './ClientServerSplit.module.scss';

type Props = PropsWithChildren & {
  serverNode: ReactNode;
};

export function ClientServerSplit({ children, serverNode }: Props) {
  const serverNodeRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (serverNodeRef.current) {
      serverNodeRef.current.remove();
    }
  }, []);

  return (
    <>
      <div ref={serverNodeRef} className={s.serverNode}>
        {serverNode}
      </div>
      {children}
    </>
  );
}
